import Item from "./item"

export default class Audio extends Item {

    get mp3src() {
        return this.data.mp3src;
    }
}
